Other section are changed now to: Start again with this code, and just change the top4 styling:

<template>
  <div
    class="page"
    :style="{transform: `scale3d(${pageScale}, ${pageScale}, 1)`, transformOrigin: 'top center'}"
  >
    <div class="container">
      <menu-home @changeIndex="changeIndex"></menu-home>
      <div class="slot"></div>
      <home-top-part></home-top-part>
      <div class="part section2">
        <!-- ... existing section 2 content ... -->
        <img
          class="item"
          src="../assets/62.png"
        >
        <div class="desc flex flex-center">
          <div
            class="desc-item btn"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/gameplay-guidance')"
          >
            <div class="img-parent">
              <img src="../assets/tower defense icon.png">
            </div>
            <div class="title">CLASSIC TOWER DEFENSE</div>
          </div>
          <div
            class="desc-item btn"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/gameplay-guidance')"
          >
            <div class="img-parent">
              <img src="../assets/zombie to earn icon.png">
            </div>
            <div class="title">ZOMBIE-TO-EARN</div>
          </div>
          <div
            class="desc-item btn"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/gameplay-guidance')"
          >
            <div class="img-parent">
              <img src="../assets/pk to earn icon.png">
            </div>
            <div class="title">PK-TO-EARN</div>
          </div>
        </div>
      </div>
      <!--vvvvvvvvvvvvvvvvvvv SECTION 3 START vvvvvvvvvvvvvvvvvvvvv-->
      <div class="part section3">

        <div class="info-title">
          <img
            class="prize-icon"
            src="../assets/prize.png"
          >
          <img
            class="info-text"
            src="../assets/51.png"
          >
        </div>
        <div class="info">
          <img
            class="info-item small-btn"
            src="../assets/52.png"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/about-we3pvz/undead-achievements')"
          >
          <img
            class="info-item small-btn"
            src="../assets/53.png"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/about-we3pvz/undead-achievements')"
          >
          <img
            class="info-item small-btn"
            src="../assets/46.png"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/about-we3pvz/undead-achievements')"
          >
          <img
            class="info-item small-btn"
            src="../assets/49.png"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/about-we3pvz/undead-achievements')"
          >
          <img
            class="info-item small-btn"
            src="../assets/50.png"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/about-we3pvz/undead-achievements')"
          >
          <img
            class="info-item info-item2 small-btn"
            src="../assets/45.png"
            @click="navLink('https://telgather.gitbook.io/web3pvz-deadpaper/about-we3pvz/undead-achievements')"
          >
        </div>
      </div>
      <!--^^^^^^^^^^^^^^^^^^^ SECTION 3 END ^^^^^^^^^^^^^^^^^^^^^-->
      <div class="part section4">
        <!-- ... existing section 4 content ... -->
        <div class="title">
          <img src="../assets/43.png">
        </div>

        <div class="top2 flex">
          <div class="top2-item">
            <img
              class="top2-item"
              src="../assets/Nomad.png"
            >
            <img
              class="top2-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top2-num"><span class="space-tip">NFT</span>{{mint3}}/ <span style="color:#fffa71">{{total3}}</span></div>
            <div class="top2-num-zbt"><span class="space-tip">SBT</span>{{mintSbt3}}</div>
          </div>
          <div class="top2-item">
            <img
              class="top2-item"
              src="../assets/Sky.png"
            >
            <img
              class="top2-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top2-num"><span class="space-tip">NFT</span>{{mint7}}/ <span style="color:#fffa71">{{total7}}</span></div>
            <div class="top2-num-zbt"><span class="space-tip">SBT</span>{{mintSbt7}}</div>
          </div>
          <div class="top2-item">
            <img
              class="top2-item"
              src="../assets/Student.png"
            >
            <img
              class="top2-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top2-num"><span class="space-tip">NFT</span>{{mint4}}/ <span style="color:#fffa71">{{total4}}</span></div>
            <div class="top2-num-zbt"><span class="space-tip">SBT</span>{{mintSbt4}}</div>
          </div>
          <div class="top2-item">
            <img
              class="top2-item"
              src="../assets/Digger.png"
            >
            <img
              class="top2-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top2-num"><span class="space-tip">NFT</span>{{mint2}}/ <span style="color:#fffa71">{{total2}}</span></div>
            <div class="top2-num-zbt"><span class="space-tip">SBT</span>{{mintSbt2}}</div>
          </div>
          <div class="top2-item">
            <img
              class="top2-item"
              src="../assets/Caretaker.png"
            >
            <img
              class="top2-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top2-num"><span class="space-tip">NFT</span>{{mint1}}/ <span style="color:#fffa71">{{total1}}</span></div>
            <div class="top2-num-zbt"><span class="space-tip">SBT</span>{{mintSbt1}}</div>
          </div>
        </div>
        <div class="top3 flex">
          <div class="top3-item">
            <img
              class="top3-item"
              src="../assets/Stella.png"
            >
            <img
              class="top3-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top3-num"><span class="space-tip">NFT</span>{{mint101}}/ <span style="color:#fffa71">{{total101}}</span></div>
            <div class="top3-num-zbt"><span class="space-tip">SBT</span>{{mintSbt101}}</div>
          </div>
          <div class="top3-item">
            <img
              class="top3-item"
              src="../assets/Hooper.png"
            >
            <img
              class="top3-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top3-num"><span class="space-tip">NFT</span>{{mint10}}/ <span style="color:#fffa71">{{total10}}</span></div>
            <div class="top3-num-zbt"><span class="space-tip">SBT</span>{{mintSbt10}}</div>
          </div>
          <div class="top3-item">
            <img
              class="top3-item"
              src="../assets/Dunker.png"
            >
            <img
              class="top3-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top3-num"><span class="space-tip">NFT</span>{{mint9}}/ <span style="color:#fffa71">{{total9}}</span></div>
            <div class="top3-num-zbt"><span class="space-tip">SBT</span>{{mintSbt9}}</div>
          </div>
          <div class="top3-item">
            <img
              class="top3-item"
              src="../assets/Boxer.png"
            >
            <img
              class="top3-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top3-num"><span class="space-tip">NFT</span>{{mint11}}/ <span style="color:#fffa71">{{total11}}</span></div>
            <div class="top3-num-zbt"><span class="space-tip">SBT</span>{{mintSbt11}}</div>
          </div>
          <div class="top3-item">
            <img
              class="top3-item"
              src="../assets/The_Judge.png"
            >
            <img
              class="top3-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top3-num"><span class="space-tip">NFT</span>{{mint109}}/ <span style="color:#fffa71">{{total109}}</span></div>
            <div class="top3-num-zbt"><span class="space-tip">SBT</span>{{mintSbt109}}</div>
          </div>
          <div class="top3-item">
            <img
              class="top3-item"
              src="../assets/Octopus.png"
            >
            <img
              class="top3-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top3-num"><span class="space-tip">NFT</span>{{mint108}}/ <span style="color:#fffa71">{{total108}}</span></div>
            <div class="top3-num-zbt"><span class="space-tip">SBT</span>{{mintSbt108}}</div>
          </div>
          <div class="top3-item">
            <img
              class="top3-item"
              src="../assets/Rocker.png"
            >
            <img
              class="top3-item-more-img"
              src="../assets/onemore.png"
            >
            <img
              class="icon"
              src="../assets/kaia.png"
              alt=""
            >
            <div class="top3-num"><span class="space-tip">NFT</span>{{mint107}}/ <span style="color:#fffa71">{{total107}}</span></div>
            <div class="top3-num-zbt"><span class="space-tip">SBT</span>{{mintSbt107}}</div>
          </div>
        </div>
        <div class="top1 flex">
          <div class="top1-item">
            <img
              class="icon"
              src="../assets/line-icon.png"
              alt=""
            >
            <img
              class="top1-item-img"
              src="../assets/1.png"
            >
            <div class="top1-item-num"><span class="space-tip">NFT</span>{{ mint6 }} / <span style="color:#fffa71">{{total6}}</span></div>
          </div>
          <div class="top1-item tinker">
            <img
              class="icon"
              src="../assets/line-icon.png"
              alt=""
            >
            <img
              class="top1-item-img"
              src="../assets/add/3.png"
            >
            <div class="top1-item-num"><span class="space-tip">NFT</span>{{ mint5 }} / <span style="color:#fffa71">{{total5}}</span></div>
          </div>
          <div class="top1-item kicker">
            <img
              class="icon"
              src="../assets/telegram-icon.png"
              alt=""
            >
            <img
              class="top1-item-img"
              src="../assets/add/6.png"
            >
            <div class="top1-item-num"><span class="space-tip">NFT</span>{{ mint8 }} / <span style="color:#fffa71">{{total8}}</span></div>
          </div>
          <div class="top1-item">
            <img
              class="icon"
              src="../assets/telegram-icon.png"
              alt=""
            >
            <img
              class="top1-item-img"
              src="../assets/3.png"
            >
            <div class="top1-item-num"><span class="space-tip">NFT</span>{{ mint102 }} / <span style="color:#fffa71">{{total102}}</span></div>
          </div>

          <div class="top1-item amber">
            <img
              class="icon"
              src="../assets/line-icon.png"
              alt=""
            >
            <img
              class="top1-item-img"
              src="../assets/add/1.png"
            >
            <div class="top1-item-num"><span class="space-tip">NFT</span>{{ mint106 }} / <span style="color:#fffa71">{{total106}}</span></div>
          </div>
          <div class="top1-item boy scout">
            <img
              class="icon"
              src="../assets/line-icon.png"
              alt=""
            >
            <img
              class="top1-item-img"
              src="../assets/add/2.png"
            >
            <div class="top1-item-num"><span class="space-tip">NFT</span>{{ mint104 }} / <span style="color:#fffa71">{{total104}}</span></div>
          </div>

          <div class="top1-item bomber">
            <img
              class="icon"
              src="../assets/telegram-icon.png"
              alt=""
            >
            <img
              class="top1-item-img"
              src="../assets/add/4.png"
            >
            <div class="top1-item-num"><span class="space-tip">NFT</span>{{  mint111}} / <span style="color:#fffa71">{{total111}}</span></div>
          </div>
          <div class="top1-item jet">
            <img
              class="icon"
              src="../assets/line-icon.png"
              alt=""
            >
            <img
              class="top1-item-img"
              src="../assets/add/5.png"
            >
            <div class="top1-item-num"><span class="space-tip">NFT</span>{{ mint112  }} / <span style="color:#fffa71">{{total112}}</span></div>
          </div>
          <div class="top1-item">
            <img
              class="icon"
              src="../assets/line-icon.png"
              alt=""
            >
            <img
              class="top1-item-img"
              src="../assets/2.png"
            >
            <div class="top1-item-num"><span class="space-tip">NFT</span>{{mint110 }} / <span style="color:#fffa71">{{ total110}}</span></div>
          </div>
          <div class="top1-item">
            <img
              class="icon"
              src="../assets/line-icon.png"
              alt=""
            >
            <img
              class="top1-item-img"
              src="../assets/draco.png"
            >
            <div class="top1-item-num"><span class="space-tip">NFT</span>{{33 }} / <span style="color:#fffa71">{{ 33}}</span></div>
          </div>
          <div class="top1-item">
            <img
              class="icon"
              src="../assets/line-icon.png"
              alt=""
            >
            <img
              class="top1-item-img"
              src="../assets/shelly.png"
            >
            <div class="top1-item-num"><span class="space-tip">NFT</span>{{66 }} / <span style="color:#fffa71">{{ 66}}</span></div>
          </div>
        </div>
        <div class="top4 flex">
          <div class="top4-item">
            <img
              class="top4-item-img"
              src="../assets/28.png"
            >
            <div class="top4-num">{{ uwa }}</div>
          </div>
          <div class="top4-item">
            <img
              class="top4-item-img"
              src="../assets/27.png"
            >
            <div class="top4-num">{{ nfts }}</div>
          </div>
          <div class="top4-item">
            <img
              class="top4-item-img"
              src="../assets/26.png"
            >
            <div class="top4-num">{{ zombies }}</div>
          </div>
          <div class="top4-item">
            <img
              class="top4-item-img"
              src="../assets/21.png"
            >
            <div class="top4-num">{{ players }}</div>
          </div>
        </div>
      </div>
      <div
        class="section5 flex flex-center"
        v-if="true"
      >
        <video
          class="videooo"
          ref="myVideo2"
          loop="loop"
          autoplay
          muted
          playsinline
          src="../assets/20250326-205002.mp4"
        ></video>
        <!-- <img
      src="../assets/coin.png"
      class="icon"
      alt=""
      srcset=""
    > -->
      </div>
    </div>

  </div>
</template>

<script>
// ... your existing script section ...
import { getInfo } from '@/common/http';
import MenuHome from './MenuHome.vue';
import HomeTopPart from './HomeTopPart.vue';

export default {
  name: 'NewHomePage',
  components: {
    MenuHome,
    HomeTopPart
  },
  data () {
    return {
      pageScale: 1, // Added pageScale to data
      uwa: '',
      zombies: '',
      players: '',
      nfts: '',
      total6: '',
      total106: "",
      mint106: "",
      total104: "",
      mint104: "",
      total5: "",
      mint5: "",
      total111: "",
      mint111: "",
      total112: "",
      mint112: "",
      total8: "",
      mint8: "",
      mint1
        :
        '',
      mint2
        :
        '',
      mint3
        :
        '',
      mint4
        :
        '',
      total1: '',
      total2: '',
      total3: '',
      total4: '',
      total7: '',
      total9: '',
      total10: '',
      total11: '',
      total101: '',
      total107: '',
      total108: '',
      total109: '',
      mintSbt1: '',
      mintSbt2: '',
      mintSbt3: '',
      mintSbt4: '',
      mintSbt7: '',
      mintSbt9: '',
      mintSbt10: '',
      mintSbt11: '',
      mintSbt101: '',
      mintSbt107: '',
      mintSbt108: '',
      mintSbt109: '',

      mint6
        :
        '',
      mint7
        :
        '', // Corrected initial value if needed or let getInfo handle it
      mint9
        :
        '', // Corrected initial value
      mint10
        :
        '', // Corrected initial value
      mint11
        :
        '', // Corrected initial value
      mint101
        :
        '', // Corrected initial value
      mint102
        :
        '',
      total102: '',
      mint107
        :
        '', // Corrected initial value
      mint108
        :
        '', // Corrected initial value
      mint109
        :
        '',
      mint110
        :
        '',
      total110: '', // Added missing data properties
    }
  },
  mounted () {
    // Commented out the zoom logic as pageScale is now used via transform: scale()
    // var percentage, appWidth = 1200;//设置默认屏幕大小
    // if (window.innerWidth < 1200) {
    //   percentage = window.innerWidth*100 / appWidth;
    //   percentage = Math.floor(percentage) / 100;
    //   this.pageScale = percentage;
    //   // document.documentElement.style.zoom = percentage;
    // }else{
    //   this.pageScale = 1;
    // }
    // this.pageScale = 1; // Keep scale 1 if you don't want the whole page scaled

    this.getInfo();
    // Consider reducing frequency if 3 seconds causes performance issues
    setInterval(() => {
      this.getInfo();
    }, 5000); // Increased interval slightly
  },
  methods: {
    changeIndex (index) {
      this.$emit("changeIndex", index);
    },
    navLink (url) {
      window.open(url, "_blank")
    },
    getInfo () {
      const formatNumber = (num) => {
        // Ensure input is a number, default to 0 if not valid
        const number = Number(num);
        if (isNaN(number)) {
          return '0'; // Or handle error appropriately
        }
        return number.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
      };

      getInfo().then(res => {
        if (res && res.data) {
          const data = res.data;
          // Use a loop or explicitly assign with formatting
          this.uwa = formatNumber(data.uwa);
          this.zombies = formatNumber(data.zombies);
          this.players = formatNumber(data.players);
          this.nfts = formatNumber(data.nfts);

          this.total1 = formatNumber(data.total1);
          this.total2 = formatNumber(data.total2);
          this.total3 = formatNumber(data.total3);
          this.total4 = formatNumber(data.total4);
          this.total5 = formatNumber(data.total5);
          this.total6 = formatNumber(data.total6);
          this.total7 = formatNumber(data.total7);
          this.total8 = formatNumber(data.total8);
          this.total9 = formatNumber(data.total9);
          this.total10 = formatNumber(data.total10);
          this.total11 = formatNumber(data.total11);
          this.total101 = formatNumber(data.total101);
          this.total102 = formatNumber(data.total102);
          this.total104 = formatNumber(data.total104);
          this.total106 = formatNumber(data.total106);
          this.total107 = formatNumber(data.total107);
          this.total108 = formatNumber(data.total108);
          this.total109 = formatNumber(data.total109);
          this.total110 = formatNumber(data.total110);
          this.total111 = formatNumber(data.total111);
          this.total112 = formatNumber(data.total112);

          this.mint1 = formatNumber(data.mint1);
          this.mint2 = formatNumber(data.mint2);
          this.mint3 = formatNumber(data.mint3);
          this.mint4 = formatNumber(data.mint4);
          this.mint5 = formatNumber(data.mint5);
          this.mint6 = formatNumber(data.mint6);
          this.mint7 = formatNumber(data.mint7);
          this.mint8 = formatNumber(data.mint8);
          this.mint9 = formatNumber(data.mint9);
          this.mint10 = formatNumber(data.mint10);
          this.mint11 = formatNumber(data.mint11);
          this.mint101 = formatNumber(data.mint101);
          this.mint102 = formatNumber(data.mint102);
          this.mint104 = formatNumber(data.mint104);
          this.mint106 = formatNumber(data.mint106);
          this.mint107 = formatNumber(data.mint107);
          this.mint108 = formatNumber(data.mint108);
          this.mint109 = formatNumber(data.mint109);
          this.mint110 = formatNumber(data.mint110);
          this.mint111 = formatNumber(data.mint111);
          this.mint112 = formatNumber(data.mint112);

          this.mintSbt1 = formatNumber(data.mintSbt1);
          this.mintSbt2 = formatNumber(data.mintSbt2);
          this.mintSbt3 = formatNumber(data.mintSbt3);
          this.mintSbt4 = formatNumber(data.mintSbt4);
          this.mintSbt7 = formatNumber(data.mintSbt7);
          this.mintSbt9 = formatNumber(data.mintSbt9);
          this.mintSbt10 = formatNumber(data.mintSbt10);
          this.mintSbt11 = formatNumber(data.mintSbt11);
          this.mintSbt101 = formatNumber(data.mintSbt101);
          this.mintSbt107 = formatNumber(data.mintSbt107);
          this.mintSbt108 = formatNumber(data.mintSbt108);
          this.mintSbt109 = formatNumber(data.mintSbt109);
          // Add mintSbt for 110 if it exists in the API response
          // this.mintSbt110 = formatNumber(data.mintSbt110);

        } else {
          console.error("Failed to fetch or parse info data:", res);
          // Optionally set default values or show an error message
        }
      }).catch(error => {
        console.error("Error fetching info:", error);
        // Optionally set default values or show an error message
      });
    }
  }
}
</script>

<!-- Styles moved below the script block -->

<style lang="scss" scoped>
.page {
  width: 100%;
  max-width: 1200px;
  overflow: hidden;
  position: relative;
  margin: 0 auto;
  transform-origin: top left;
}

.section5 {
  margin: 0 auto;
  width: 100% !important;
  zoom: 0.65;
}

.section4{
  zoom: 0.65;
}

.section3{
  zoom: 0.65;
}

.section2{
  zoom: 0.65;
}

.section5 .videooo {
  width: 100% !important;
  left: 50%!important;
  transform: translateX(-50%);
}

@media (max-width: 768px) {
  .section4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    zoom: 1;
  }
  .section4 .title,
  .section4 .top2,
  .section4 .top3,
  .section4 .top1,
  .section4 .top4 {
    justify-content: center;
    display: flex;
    margin-bottom: 0px; /* Reduced margin */
  }
  .top2-item .icon,
  .top3-item .icon,
  .top1-item .icon {
    display: none;
  }

  .top2-num,
  .top2-num-zbt,
  .top3-num,
  .top3-num-zbt,
  .top1-item-num {
    display: none;
  }

  .top3-num {
    margin-bottom: 1px;
    margin-left: 0;
  }
  .top3-num-zbt {
    bottom: 50px;
    margin-left: 0;
  }
}
</style>

<style lang="scss" scoped>
.page {
  width: 100%; // Use 100% instead of 100vw for scaling parent
  // min-width: 1200px; /* Optional: Set a minimum width if scaling causes issues */
  overflow: hidden;
  position: relative;
  // margin: 0 auto; /* Centering if needed, but scaling might affect this */
  transform-origin: top left;
}

@media (max-width: 768px) {
  .top1,
  .top2,
  .top3 {
    transform: scale(0.9);
    transform-origin: top center;
    display: block;
    white-space: nowrap;
    padding: 0 0px 00px;
    width: 100%;
  }

  .top4 {
    transform: scale(0.765); /* Further reduced scale */
    transform-origin: top center;
    padding: 0 0;

    &-item-img {
      max-width: 70px; /* Reduced image size for smaller screens */
    }

    .top4-num {
      font-size: 14px; /* Adjusted font size */
    }
  }
}
.container {
  background: (url('../assets/bg.jpg'));
  background-size: cover; // Ensure background covers the area
  background-position: center top; // Adjust as needed
  background-repeat: no-repeat;
  width: 100%; // Use 100% to fill the scaled parent
  overflow: hidden; // Keep hidden
  min-height: 100vh; // Ensure it takes at least the viewport height
}

.relative {
  position: relative;

  .btn2 {
    position: absolute;
    top: 0;
    left: 0;
  }
  .btn1 {
    position: absolute;
    top: 0px;
    left: 800px; // This might need responsive adjustments too
  }
}

.slot {
  height: 152px; // This could potentially be adjusted with media queries if needed
  width: 100%;
}

.flex {
  display: flex;
  // max-width: 90vw;
}

.flex-center {
  justify-content: center;
  align-items: center;
}
.part {
  min-height: 500px; // Use min-height instead of fixed height for flexibility
  padding-bottom: 50px; // Add some padding at the bottom
}

.section2 {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgba($color: #000000, $alpha: 0.1);
  padding-top: 50px; // Adjust as needed, maybe was 920px before? Review this.
  min-height: auto; // Override default part min-height if needed

  .item {
    // padding-top: 920px; // Removed padding from image, added to section container
    width: 60%; // Make width relative
    max-width: 60%; // Keep max width
    height: auto; // Ensure aspect ratio is maintained
    display: block; // Helps with margin auto
    margin: 0 auto; // Center the image if needed
  }
  .desc {
    flex-wrap: wrap; // Allow items to wrap on smaller screens
    justify-content: center; // Center wrapped items
    gap: 20px; // Add gap between items
    width: 100%;
    padding: 20px; // Add padding for spacing

    .desc-item {
      padding: 20px; // Reduce padding
      width: 100%; // Take full width on small screens
      max-width: 300px; // Set a max-width for larger screens
      box-sizing: border-box; // Include padding in width calculation
      text-align: center; // Center text

      .img-parent {
        min-height: auto; // Remove fixed min-height
        height: 200px; // Set a fixed height or use aspect ratio padding trick
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 15px; // Space below image

        img {
          max-height: 100%; // Ensure image fits within parent
          max-width: 90vw;
          object-fit: contain; // Scale image nicely
        }
      }
      .title {
        color: white;
        padding: 10px;
        height: auto; // Auto height
        line-height: 1.3; // Adjust line height
        font-size: 18px; // Adjust font size
        font-weight: bold;
        background-color: rgba($color: #2d3b53, $alpha: 1);
        border-radius: 10px; // Slightly smaller radius
        display: inline-block; // To contain background to text size
        min-width: 80%; // Ensure it's not too narrow
        max-width: 90%;
      }
    }
  }
}

// ===================================
// SECTION 3 STYLES START
// ===================================
.section3 {
  min-height: auto; // Override default part min-height if needed
  padding: 50px 0; // Add vertical padding

  .info-title {
    margin-top: 50px; // Reduced top margin significantly
    text-align: center; // Center title elements
  }

  .prize-icon {
    width: 40%; // Relative width
    max-width: 250px; // Max width
    height: auto; // Maintain aspect ratio
    display: block; // For margin auto
    margin: 0 auto 10px auto; // Center and add bottom margin
  }

  .info-text {
    width: 80%; // Relative width
    max-width: 800px; // Max width
    height: auto; // Maintain aspect ratio
    // padding-top: -30px; // Removed negative padding
    display: block; // For margin auto
    margin: 0 auto; // Center
  }

  .info {
    display: flex;
    flex-direction: column;
    // justify-content: space-around; // Keep or change to space-evenly/flex-start
    align-items: center; // Center items horizontally
    border-radius: 10px;
    width: auto; // Relative width
    max-width: 1200px; // Set a reasonable max-width, less than the original 1727px
    height: auto; // Auto height
    background-color: #0a0f22;
    margin: 32px auto 0 auto; // Center horizontally, maintain top margin
    padding: 30px 15px; // Adjust padding (vertical, horizontal)
    box-sizing: border-box; // Include padding in width

    .info-item {
      margin-left: 0;
      width: 100%;
      height: auto;
      max-width: 100%;
      margin-bottom: 10px;
      object-fit: contain;
      flex-shrink: 0;

      &:last-child {
        margin-bottom: 0; // No margin for the last item
      }
    }

    .info-item2 {
      // margin-left: 0; // Removed fixed left margin (inherited)
      height: auto; // Slightly reduced base height
    }
  }
}
// ===================================
// SECTION 3 STYLES END
// ===================================

.section4 {
  // margin-top: 60px; // Keep or adjust
  min-height: auto; // Override part height
  height: auto; // Let content dictate height
  position: relative;
  zoom: 1;
  z-index: 99; // Keep z-index if needed for layering
  // transform: translateZ(99px); // Be cautious with 3D transforms, might affect layout/scaling
  padding-bottom: 50px; // Add padding at the bottom

  .title {
    width: 80%; // Relative width
    max-width: 592px; // Max width
    height: auto;
    display: block;
    margin: 0 auto; // Center title image
    // transform: translateX(-42px); // Removed fixed transform, rely on margin auto
  }

  // General approach for top1, top2, top3: use flex-wrap and gap
  .top1,
  .top2,
  .top3 {
    display: flex;
    flex-wrap: nowrap; // Prevent items from wrapping
    justify-content: center; // Center items
    gap: 2px; // Reduce gap between items
    padding: 0 10px; // Add horizontal padding to container
  }

  // Specific adjustments might be needed per topX group if base images vary a lot

  .top1 {
    gap: -2px; // Smaller gap if needed
    .top1-item {
      position: relative;
      width: clamp(80px, 10vw, 250px); // Responsive width with min/max
      margin-left: 0; // Remove fixed margin

      .icon {
        width: 30px; // Smaller icon
        height: 30px;
        position: absolute;
        top: 25px; // Adjust position
        right: 5px;
        z-index: 10; // Ensure icon is above image
      }
      .top1-item-img {
        width: 100%; // Make image fill container
        height: auto;
        display: block;
      }
      .top1-item-num {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0px; // Position from bottom
        top: auto; // Override fixed top
        // margin-left: -40px; // Remove fixed margin
        color: white;
        font-size: clamp(8px, 1.5vw, 14px); // Smaller font size
        line-height: 1.2;
        font-weight: bold;
        white-space: nowrap;
        background-color: rgba(
          0,
          0,
          0,
          0.5
        ); // Optional background for readability
        padding: 1px 3px; // Adjust padding
        border-radius: 3px; // Adjust border radius
      }
      // Remove specific class positioning like .tinker, .kicker if flex-wrap handles it
    }
  }

  .top2 {
    .top2-item {
      position: relative;
      width: clamp(140px, 18vw, 190px); // Responsive width
      margin-left: 0;

      .icon {
        width: 30px;
        height: 30px;
        position: absolute;
        top: 50px;
        right: 5px;
        z-index: 11;
      }
      .top2-item-img, // Target both img elements if first is character
      & > img:first-of-type {
        // More specific selector if needed
        width: 100%;
        height: auto;
        display: block;
      }
      .top2-item-more-img {
        width: 100%;
        height: auto;
        display: block;
        margin-top: -5px; // Adjust overlap if needed
      }
      .top2-num,
      .top2-num-zbt {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        color: white;
        font-size: clamp(12px, 1.8vw, 14px);
        line-height: 1;
        font-weight: bold;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 2px 5px;
        border-radius: 4px;
        width: max-content; // Ensure background fits content
      }
      .top2-num {
        bottom: 3px;
        top: auto;
        position: absolute;
        margin-left: 0;
      } // Position near bottom
      .top2-num-zbt {
        bottom: 30px;
        position: absolute;
        top: auto;
        margin-left: 0;
      }
    }
  }

  .top3 {
    .top3-item {
      position: relative;
      width: clamp(130px, 16vw, 180px); // Responsive width
      margin-left: 0;

      .icon {
        width: 30px;
        height: 30px;
        top: 50px;
        right: 5px;
        z-index: 11;
        position: absolute;
      }
      .top3-item-img, // Target both img elements if first is character
      & > img:first-of-type {
        width: 100%;
        height: auto;
        display: block;
      }
      .top3-item-more-img {
        width: 100%;
        height: auto;
        display: block;
        margin-top: -5px;
      }
      .top3-num,
      .top3-num-zbt {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        white-space: nowrap;
        color: white;
        font-size: clamp(10px, 1.8vw, 14px);
        line-height: 1;
        font-weight: bold;
        background-color: rgba(0, 0, 0, 0.5);
        padding: 2px 5px;
        border-radius: 4px;
        width: max-content;
      }
      .top3-num {
        bottom: 2px;
        top: auto;
        position: absolute;
        margin-left: 0;
      }
      .top3-num-zbt {
        bottom: 26px;
        position: absolute;
        top: auto;
        margin-left: 0;
      }
    }
  }

  .top4 {
    margin-top: 60px;
    display: flex;
    justify-content: center;
    align-items: center; // Center vertically
    flex-wrap: wrap;
    flex-direction: row;
    gap: 15px;

    .top4-item {
      position: relative;
      width: clamp(180px, 40vw, 300px);
      margin-left: 0;

      .top4-item-img {
        width: 100%;
        height: auto;
        display: block;
      }

      .top4-num {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 45%;
        color: white;
        font-size: clamp(24px, 4vw, 32px);
        line-height: 1;
        font-weight: bold;
        text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.7);
      }
    }
  }

  @media (max-width: 767.98px) {
    .top4 {
      margin-top: 40px;
    }
  }
  @media (max-width: 572px) {
    .top4 {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 8px; /* Reduced gap for better spacing */
    }
    .top4-item {
      width: 100%;
    }
    .top4-item .top4-num {
      font-size: clamp(14px, 4vw, 20px); /* Adjusted font size */
    }
  }

  @media (max-width: 400px) {
    .top4 {
      gap: 4px; /* Further reduced gap */
    }
    .top4-item .top4-num {
      font-size: clamp(10px, 4vw, 14px); /* Further adjusted font size */
    }
  }
} // Closing tag for .section4 styles was missing here

@keyframes scale {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

// General icon styles if needed outside specific sections
// .icon { ... }

.space-tip {
  padding-top: 10px;
  margin-top: -20px;
  margin-right: 5px; // Reduced space
  display: inline-block;
  font-size: 0.9em; // Relative size to parent number
  opacity: 0.9; // Slightly less prominent
}

.section5 {
  position: relative; // Needed for absolute positioning of video
  width: 100%;
  zoom: 1;
  height: 100vh; // Example: Set a height for the section
  min-height: 400px; // Or a minimum height
  overflow: hidden; // Hide parts of video extending outside
}

.videooo {
  position: absolute; // Position relative to .section5
  top: 0;
  left: 0;
  width: 100%;
  height: 100%; // Fill the container
  -o-object-fit: cover;
  object-fit: cover; // Cover the area, cropping if necessary
  z-index: 1; // Keep behind other content if needed
}

// ==============================================
// MEDIA QUERIES for further fine-tuning if needed
// ==============================================

/* Small devices (phones, less than 768px) */
@media (max-width: 767.98px) {
  .section5 {
    width: 100vw; // Make section5 full width
  }
  .videooo {
    width: 100vw; // Make video full width on mobile
    height: auto; // Maintain aspect ratio
    margin: 0; // Remove any margin
    left: 0; // Ensure it's aligned to the left
    transform: none; // Remove transform
  }
  .top1 {
    .top1-item-num {
      font-size: clamp(6px, 1.125vw, 10.5px);
    }
  }
  .top2 {
    .top2-num,
    .top2-num-zbt {
      font-size: clamp(7.5px, 1.125vw, 10px);
    }
  }
  .top3 {
    .top3-num,
    .top3-num-zbt {
      font-size: clamp(7.5px, 1.35vw, 10.5px);
    }
  }
  .top1,
  .top2,
  .top3 {
    margin: 0 auto;
  }
  .top1 {
    width: 90vw;
  }
  .top2 {
    width: 70vw;
  }
  .top3 {
    width: 80vw;
  }
  .section3 {
    .info-title {
      margin-top: 30px;
    }
    .prize-icon {
      max-width: 180px;
    }
    .info-text {
      max-width: 90%;
    }
    .info {
      width: 95%;
      padding: 20px 10px;
      .info-item {
        height: 40px;
        margin-bottom: 15px;
      }
      .info-item2 {
        height: 55px;
      }
    }
  }

  .section4 {
    zoom: 1;
    .title {
      width: 100%;
      max-width: 90vw;
      margin: 0 auto;
      padding: 0 5%;
      box-sizing: border-box;
    }
    .title img {
      max-width: 100%;
      height: auto;
      display: block;
      margin: 0 auto;
    }
    // .section4 { // This rule was nested inside another .section4 rule, removed nesting
    //   width: 90vw;
    // }
    .top4 {
      margin-top: 40px;
      justify-content: center; // Ensure top4 is centered
    }
    .top4 .top4-item {
      width: clamp(250px, 45vw, 250px);
      display: flex;
      flex-direction: column;
      align-items: center; // Center the content of top4-item
    }
    .top4 .top4-item-img {
      max-width: 80%; // Make sure the image is not too wide
      height: auto;
      margin: 0 auto; // Center the image
    }
    .top4 .top4-num {
      font-size: clamp(20px, 5vw, 28px);
    }
  }

  .section2 .item {
    // padding-top: 920px; // Removed padding from image, added to section container
    width: 90%; // Make width relative
    max-width: 90%; // Keep max width
  }

  .section2 .desc .desc-item {
    max-width: 280px; // Slightly smaller max-width on phones
  }
  .section2 .desc .desc-item .img-parent {
    height: 150px; // Smaller image area on phones
  }
  .section2 .desc .desc-item .title {
    font-size: 16px;
  }
}

/* Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991.98px) {
  .section3 {
    .info {
      max-width: 700px;
    } // Adjust max-width for tablets
  }
  .section2 .desc {
    gap: 30px;
  }
  .section2 .desc .desc-item {
    max-width: 240px; // Example: 3 items per row
  }
}

/* Large devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .section3 {
    .info {
      max-width: 900px;
    } // Adjust max-width for desktops
  }
  .section2 .desc {
    gap: 40px;
  }
  .section2 .desc .desc-item {
    max-width: 300px; // Back to original max-width approx
  }
}

/* Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .section3 {
    .info {
      max-width: 1100px;
    } // Closer to original concept width
  }
}
</style>

<style scoped>
/* This style block is specifically scoped */
@media (max-width: 768px) {
  .videooo {
    display: none;
  }
}
</style>
